//注册页面组件
import Login from '../pages/Login' //登录
import Index from '../pages/Home/Index' //首页 词典
import Translate from '../pages/Home/Translate' //翻译

import NotFound from '../pages/NotFound' //404


let router = [{
    path: '/', //首页默认加载的页面
    component: Index,
    element: < Index />,
    exact: true //是否为严格模式
}, {
    path: '/user', //首页默认加载的页面
    component: Login,
    element: < Login />,
    exact: true //是否为严格模式
}, {
    path: '/index', //首页默认加载的页面
    component: Index,
    element: < Index />,
    exact: true //是否为严格模式
}, {
    path: '/translate', //首页默认加载的页面
    component: Translate,
    element: < Translate />,
    exact: true //是否为严格模式
},{
    path: '/404',
    component: NotFound,
    element: < NotFound />
}]
export default router;
